export default function SEOArticleHero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/cf7a0be3ce129a69e0ff54571e64f4ed.jpg"
          alt="SEO-статьи для бизнеса"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1A2B4C]/60 via-[#1A2B4C]/50 to-[#1A2B4C]/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-6xl mx-auto px-4 sm:px-6 py-24 sm:py-28 text-center">
        <div className="inline-flex items-center gap-2 bg-[#C5A880]/40 border border-[#C5A880]/80 text-[#FFE0A8] px-3 sm:px-4 py-2 rounded-full text-xs font-semibold mb-5 font-['Montserrat'] backdrop-blur-sm">
          <i className="ri-article-line"></i>
          <span>SEO-контент &amp; Контент-маркетинг</span>
        </div>

        <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-['Playfair_Display'] font-bold text-white mb-5 leading-tight px-1">
          SEO-статьи: как превратить ваш сайт{' '}
          <span className="block sm:inline">в конвейер бесплатных заявок из поиска</span>
        </h1>

        <p className="text-sm sm:text-lg text-white font-semibold mb-5 max-w-4xl mx-auto leading-relaxed font-['Montserrat'] px-1" style={{ textShadow: '0 1px 8px rgba(0,0,0,0.55)' }}>
          Пишем профессиональные SEO-статьи, которые решают проблемы ваших клиентов и выводят ваш бизнес в ТОП Google и Яндекса без затрат на рекламу.
        </p>

        <div className="inline-block bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl px-4 sm:px-6 py-3 sm:py-4 mb-8 mx-4">
          <p className="text-xs sm:text-base text-white font-medium font-['Montserrat']">
            Используем глубокую маркетинговую стратегию и возможности ИИ для роста вашего бизнеса.
          </p>
        </div>

        {/* Traffic growth visual */}
        <div className="mb-8 max-w-2xl mx-auto px-1">
          <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-4 sm:p-6">
            <div className="flex items-center justify-between mb-3">
              <span className="text-white/60 text-xs font-['Montserrat']">Органический трафик</span>
              <span className="text-[#C5A880] text-xs font-bold font-['Montserrat']">+340% за 6 месяцев</span>
            </div>
            <div className="flex items-end gap-1 sm:gap-1.5 h-14 sm:h-20">
              {[20, 25, 35, 42, 55, 63, 72, 80, 88, 95, 100, 100].map((h, i) => (
                <div key={i} className="flex-1 rounded-t-sm bg-[#C5A880] transition-all" style={{ height: `${h}%`, opacity: 0.4 + (i / 11) * 0.6 }}></div>
              ))}
            </div>
            <div className="flex justify-between mt-2">
              <span className="text-white/40 text-xs font-['Montserrat']">Январь</span>
              <span className="text-white/40 text-xs font-['Montserrat']">Июнь</span>
              <span className="text-[#C5A880] text-xs font-semibold font-['Montserrat']">Сейчас</span>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center px-4">
          <a
            href="#seo-article-form"
            className="group w-full sm:w-auto bg-[#C5A880] hover:bg-[#B39770] text-white px-7 py-4 rounded-full text-sm font-semibold transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer font-['Montserrat'] text-center"
          >
            Заказать контент-стратегию
            <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform inline-block"></i>
          </a>
          <a
            href="#seo-what-is"
            className="group w-full sm:w-auto bg-white/20 backdrop-blur-md hover:bg-white/30 text-white border-2 border-white/40 px-7 py-4 rounded-full text-sm font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer font-['Montserrat'] text-center"
          >
            Узнать подробнее
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
